<template>
  <div class="internal short-page about">
    <div class="container">
      <h1>About Us</h1>
      <hr />
      <p>
        Welcome to SEA Scaffolding – Your Trusted Scaffolding Experts in Beccles.
        <br />
        <br />At SEA Scaffolding, we provide reliable, safe, and professional scaffolding solutions for residential, commercial, and industrial projects across East Anglia and the surrounding areas. 
        With years of experience in the industry, our team is committed to delivering high-quality scaffolding services, ensuring your project runs smoothly from start to finish.
        <br />
        <br />Whether you need temporary access for renovations, extensions, roofing, or large-scale construction, we tailor our scaffolding to suit your specific requirements. Safety is our priority, 
        and we adhere to the highest industry standards, ensuring a secure and efficient working environment for all trades.
        <br />
        <br />Due to the varying complexity levels of the work we undertake all of our staff have the relevant competency certificates and training.
        <br />
        <br />Choose SEA Scaffolding for a dependable, competitively priced, and expertly installed scaffolding service. Get in touch today for a free consultation and quote – let’s build your project on a solid foundation!
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "about-us",
};
</script>



// WEBPACK FOOTER //
// src/components/pages/AboutUs.vue